// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"e031feee","738":"03837d1d"}[chunkId] + ".chunk.css";
};